import SetPasswordForm from './SetPasswordForm';

export default SetPasswordForm;
